var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNiger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_861)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.98447 11.3043C0.713064 13.9337 -6.10352e-05 16.8835 -6.10352e-05 20C-6.10352e-05 23.1164 0.713064 26.0662 1.98447 28.6956L19.9999 30.4347L38.0154 28.6956C39.2868 26.0662 39.9999 23.1164 39.9999 20C39.9999 16.8835 39.2868 13.9337 38.0154 11.3043L19.9999 9.56519L1.98447 11.3043Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.98517 28.6956C5.22001 35.3855 12.0707 40 19.9999 40C27.9291 40 34.7798 35.3855 38.0147 28.6956H1.98517Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.98523 11.3044H38.0148C34.7799 4.61445 27.9291 0 20 0C12.0709 0 5.22007 4.61445 1.98523 11.3044Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 26.9565C23.8419 26.9565 26.9564 23.842 26.9564 20C26.9564 16.158 23.8419 13.0435 19.9999 13.0435C16.158 13.0435 13.0435 16.158 13.0435 20C13.0435 23.842 16.158 26.9565 19.9999 26.9565Z",
    fill: "#FF9811"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_861"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNiger);
export default __webpack_public_path__ + "static/media/niger.1744b470e4a8e71b50117fb908c6ecae.svg";
export { ForwardRef as ReactComponent };